module.exports = __webpack_public_path__ + "img/delicacies.4b985edc.png";